<template>
    <div class="container">
        <div class="row">
                <div class="col-sm text-justify">
                    <br><br><br>
                    « Chouf-Avis » vous permet de consulter les avis émis par l’Agence Urbaine concernant votre dossier en Deux clics seulement à tout moment et quelque soit votre emplacement.
            Il suffit d’insérer le numéro du dossier généré par la plateforme nationale « Rokhas » ou le n° de votre titre foncier pour avoir accès au dernier avis émis, par cette Agence urbaine, avec la possibilité de défiler l’historique dudit dossier.

                </div>
            
                    <div class="col-sm text-end text-justify">
                        <br><br><br>
                        تتيح لك الخدمة الجديدة "شوف-أڤي" الاطلاع على الآراء الصادرة عن الوكالة الحضرية بشأن ملفكم، أينما تواجدتم وفي أي وقت ترغبون فيه وذلك بواسطة نقرتين فقط.
                ما عليكم سوى إدخال رقم ملفكم الذي حصلتم عليه من المنصة الوطنية "رخص" أو رقم رسمكم العقاري من أجل الاطلاع على آخر رأي مبدى من طرف الوكالة الحضرية، وذلك مع إمكانية الرجوع إلى كافة الآراء المبداة فيما سبق حول مشروعكم.

                    </div>
        </div>
    </div>
        <div class="container text-start">
                <form @submit.prevent="submitform">
                   <br/>
                    <b> Nature Projet:</b> <br/><br/>
                    <input type="radio" id="one" value="GP" v-model="picked" /> &nbsp;&nbsp;&nbsp;&nbsp;
            <label for="one">Grand Projet</label>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <input type="radio" id="two" value="PP" v-model="picked" />&nbsp;&nbsp;&nbsp;&nbsp;
            <label for="two">Petit Projet</label>
                    
            <br/><br/>
                        <input type="text" 
                        placeholder="Veuillez Saisir Numéro Rokhas ou n° du Titre foncier"
                        name="numerorokhas" 
                        class="form-control" v-model="rokhas"/>
                        
                        </form>
                <br/> 
 <div v-if="this.picked=='GP'" >
    
    <ul v-if="this.rokhas">  
        <div v-for="dossier,index in dossiers.filter(dossier=>
        dossier.numdossiercommune==this.rokhas | 
        dossier.referencefonciere==this.rokhas )"
        v-bind:key="dossier.rokhas" style="float: left;"
        >
        <div v-if="index==0" class="card">
        <div class="card-body">

            <b>Instruction AUKSS en date du:</b>  {{ dossier.dateinstruction }} <br/>
            <b>Titre foncier:</b>  {{ dossier.referencefonciere }} <br/>
            <b>Numéro Rokhas:</b>  {{ dossier.numdossiercommune }} 
        <br/>
        <b> Commune: </b> {{ dossier.nom_fr }} <br/>
        <b>Avis:</b><span :class="dossier.avistech=='Défavorable' ?'badge badge-danger':'badge badge-success'">{{ dossier.avistech }}</span> <br/>
        <br/>
        <b>Observations de l'AUKSS:</b>
        <h5 v-html="dossier.remarques.replace(regex, '.<br/>')"></h5>
        <br/>
        
        <br><br>
        <hr style="border: 8px solid darkgreen;
        border-radius: 5px;"/>
        
        <div>
            <div style="width: 20%; float: left; text-align: center;">
                
        <b> <i>Si vous avez besoin de plus d'information,<br> veuillez nous contacter</i></b>

        <a href="https://aukenitra.org/fa/fr/indexRD.php?p=Rendez-vous" target="_blank"><img  src="images.png" alt="Smiley face" style="width:140px"></a>
        
            <!--<a class="badge text-bg-primary"  href="https://aukenitra.org/fa/fr/indexRD.php?p=Rendez-vous"
            target="_blank"> Prise de Rendez-Vous </a> 
            -->
            <br/>   <br/>    
            </div>
            <div  style="float: left; text-align: center;" v-if="afficher1">
                <b> <i>Consulter l'historique <br> des observations du dossier</i></b><br><br>
                <img style="width: 120px"  src="tlchargeme.jpg" alt="Smiley face"   v-on:click="test()" v-if="afficher1">
            <!-- <button class="badge badge-info"  v-on:click="test()" v-if="afficher1" >Historique du Dossier</button>-->
        </div>
        </div>
        </div>
        </div>
        <br/><br/>
        </div>
    </ul>
 
            
                <div  v-if="this.rokhas" >
            <div v-for="dossier in dossiersall.filter(dossier=>
            dossier.numdossiercommune==this.rokhas | 
            dossier.referencefonciere==this.rokhas )"
            v-bind:key="dossier.rokhas"   

            >
            <b>Instruction AUKSS en date du:</b>{{ dossier.dateinstruction }} <br/>
                <b>  Titre Foncier:</b>  {{ dossier.referencefonciere }} <br/>
                    <b>  Numéro Rokhas: </b> {{ dossier.numdossiercommune }} 
            <br/>
            <b> Commune: </b> {{ dossier.nom_fr }} <br/>
                <span style="width:100px" :class="dossier.avistech=='Défavorable' ?'badge badge-danger':'badge badge-success'">{{ dossier.avistech }}</span> <br/>
            <br/>
            <h4 v-html="dossier.remarques.replace(regex, '.<br/>')"></h4>

            <hr style="border: 8px solid darkred;
            border-radius: 5px;"/>
 
</div>

</div>    

</div>
<div v-else-if="this.picked=='PP'">
<ul v-if="this.rokhas">
    <div v-for="dossier,index in dossierspp.filter(dossier=>
        dossier.numdossiercommune==this.rokhas | 
        dossier.referencefonciere==this.rokhas )"
        v-bind:key="dossier.rokhas" style="float: left;"
        >
        <div v-if="index==0" class="card">
        <div class="card-body">

            <b>Instruction AUKSS en date du:</b>  {{ dossier.dateinstruction }} <br/>
            <b>Titre foncier:</b>  {{ dossier.referencefonciere }} <br/>
            <b>Numéro Rokhas:</b>  {{ dossier.numdossiercommune }} 
        <br/>
        <b> Commune: </b> {{ dossier.nom_fr }} <br/>
        <b>Avis:</b><span :class="dossier.avis_fr=='Défavorable' ?'badge badge-danger':'badge badge-success'">{{ dossier.avis_fr }}</span> <br/>
        <br/>
     
        
        <br><br>
        <hr style="border: 8px solid darkgreen;
        border-radius: 5px;"/>
        
        <div>
            <div style="width: 20%; float: left; text-align: center;">
                
        <b> <i>Si vous avez besoin de plus d'information,<br> veuillez nous contacter</i></b>

        <a href="https://aukenitra.org/fa/fr/indexRD.php?p=Rendez-vous" target="_blank"><img  src="images.png" alt="Smiley face" style="width:140px"></a>
        
            <!--<a class="badge text-bg-primary"  href="https://aukenitra.org/fa/fr/indexRD.php?p=Rendez-vous"
            target="_blank"> Prise de Rendez-Vous </a> 
            -->
            <br/>   <br/>    
            </div>
            <div  style="float: left; text-align: center;">
                <b> <i>Consulter l'historique <br> des observations du dossier</i></b><br><br>
                <img style="width: 120px"  src="tlchargeme.jpg" alt="Smiley face"  >
            <!-- <button class="badge badge-info"  v-on:click="test()" v-if="afficher1" >Historique du Dossier</button>-->
        </div>
        </div>
        </div>
        </div>
        <br/><br/>
        </div>
</ul>
</div>
<div class="d-flex justify-content-center"
    style ="text-align: center;
        position: relative;
        margin-bottom: 25px;
        margin-left: 15px;
        margin-right: 15px;
        margin-top: 15px;
        float: left;
        width: 100%;
        color: #a62021;"><h3> <b>Nos Statistiques au titre de l'année 2025</b>
        
    </h3> 
    </div>
    <div class="d-flex justify-content-center"
    style ="text-align: center;
        position: relative;
        margin-bottom: 25px;
        margin-left: 15px;
        margin-right: 15px;
        margin-top: 15px;
        float: left;
        width: 100%;
        color: #a62021;"><h3> <b>
    الإحصائيات  برسم سنة 2025</b>
        
    </h3> 


    </div>
    <div class="row">
        <div class="col-sm text-justify p-3 mb-2" style=" border-radius: 25px;
        background-color: darkGray;">
            <i class="fas fa-building"></i> &nbsp;&nbsp;Grand Projets: 
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;<b>1422</b>&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :المشاريع الكبرى <br/>
          

        </div>
        &nbsp;&nbsp;   &nbsp;&nbsp;
        <div class="col-sm text-justify p-3 mb-2 " style=" border-radius: 25px; 
        background-color: Coral">
            <i class="fas fa-home"></i> &nbsp;&nbsp; Petit Projets:&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;<b>6752</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;
            : المشاريع الصغرى <br />

        </div>
        &nbsp;&nbsp;   &nbsp;&nbsp;
        <div class="col-sm text-justify p-3 mb-2 " style=" border-radius:25px;
        background-color: darkkhaki;">
            <i class="fas fa-file"></i>&nbsp;&nbsp;&nbsp;
            Note de renseignements :<b>600 </b> :بطاقة المعلومات التعميرية

        </div>
    </div> 
        </div>


    

</template>
    
    
    
    <script>
import axios from 'axios'

        export default {
          
            computed:{
            
    
        
          },
         
            mounted() {
              //  console.log(this.dossiers[0])
          this.Dossiers(),
          this.dossiersPetit()

         
        },
            created(){
           this.dossiersPetit()
            },
            data(){
                return {
                    picked:"",
                    dossiers:[],
                    dossierspp:[],
                    testaffi:true,
                    nombre:14,
                    dateNow:'',
                    nombres:[], 
                    rokhas:'',
                    firstelem:'',
                    regex : /;+/ig,
                    
                    afficher1:true,
                    dossiersall:[],
                    dossiersallpp:[],
                    afficher3:true
                }
            },
            methods:{
                test1(){
                    this.afficher3=false,
                    this.DossiersPPall()
                },
                test(){
                    this.Dossiersall(),
                    this.afficher=true,
                    this.afficher1=false
                },
                submitform(e)
                {
                    e.preventDefault();
                    console.log(e);
                },      
                dossiersPetit(){
                    axios.get('http://98.71.11.165/aukss-app1/public/avispp'
                   
                   )
               .then(response => (this.info = response,
              //console.log('data: '+response),
             this.dossierspp=response.data,
             console.log(this.dossierspp)
            // console.log(this.dossiers),
           
          
            
              
               ));
                }, 
                  DossiersPPall(){
                    axios.get('http://98.71.11.165/aukss-app1/public/avispp'
                   
                   )
               .then(response => (this.info = response,
              //console.log('data: '+response),
             this.dossiersppall=response.data,
            // console.log(this.dossiers),
            this.testaffi=false,
             this.firstelem=this.dossiers.shift()
         
            
              
               ));
                },      
                Dossiersall(){
                    axios.get('http://98.71.11.165/aukss-app1/public/avis'
                   
                   )
               .then(response => (this.info = response,
              //console.log('data: '+response),
             this.dossiersall=response.data,
            // console.log(this.dossiers),
            this.testaffi=false,
             this.firstelem=this.dossiers.shift()
         
            
              
               ));
                },
                Dossiers(){
                    axios.get('http://98.71.11.165/aukss-app1/public/avis'
                   
                   )
               .then(response => (this.info = response,
              //console.log('data: '+response),
             this.dossiers=response.data,
            // console.log(this.dossiers),
             this.firstelem=this.dossiers.shift()
         
            
              
               ));
                }
               
              
            }
        }
    </script>
    